import { z } from 'zod'
import { enumerated } from '~/prix'
import { dateOrIsoString } from '~/prix/types/date'
import sql from '~/prix/utils/sql'

export const materialTypeValues = enumerated({
  seeds: 'Sementes',
  fertilizers: 'Adubos',
  seedlings: 'Mudas',
  others: 'Outros',
})

export const materialObject = z.object({
  id: z.string().uuid(),
  clientId: z.number().int(),
  name: z.string(),
  type: materialTypeValues,
  description: z.string().nullish(),
  buyDate: dateOrIsoString().nullish(),
  noteNumber: z.string().nullish(),
  supplier: z.string().nullish(),
  sourceFilter: z.string().nullish(),
  insertUserId: z.string().nullish(),
  editUserId: z.string().nullish(),
  createdAt: dateOrIsoString().nullish(),
  updatedAt: dateOrIsoString().nullish(),
  deletedAt: dateOrIsoString().nullish(),
})

export type MaterialType = z.infer<typeof materialObject>

export const propertyMap = {
  id: sql`material.id`,
  clientId: sql`material.client_id`,
  name: sql`material.name`,
  type: sql`material.type`,
  description: sql`material.description`,
  buyDate: sql`material.buy_date`,
  noteNumber: sql`material.note_number`,
  supplier: sql`material.supplier`,
  sourceFilter: sql`material.source_filter`,
  insertUserId: sql`material.insert_user_id`,
  editUserId: sql`material.edit_user_id`,
  createdAt: sql`material.created_at`,
  updatedAt: sql`material.updated_at`,
  deletedAt: sql`material.deleted_at`,
}
